import React, { useState, useEffect, useRef } from 'react';
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import ToggleSwitch from '../../visualComponents/ToggleSwitch.js';
import { useNavigate } from 'react-router-dom';
import Loader from '../../visualComponents/Loader.js';

let isLoading = false;

const ImpostazioniManager = () => {
    const [preavviso, setPreavviso] = useState(0);
    const [mailRiepilogo, setMailRiepilogo] = useState(0);
    const [originalData, setOriginalData] = useState({});
    const navigate = useNavigate();
    const toggleRef = useRef(null);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setPreavviso(originalData.GiorniPreavvisoManutenzione);
        if(toggleRef.current){
            toggleRef.current.setValue(originalData.InvioMailRiepilogo);
        }
        setMailRiepilogo(originalData.GiorniMailRiepilogo);
    }, [originalData]);

    const onload = async () => {
        try {
            isLoading = true;

            await loadNav();

            //getParametri
            const r2 = await fetch("/getParametriManager", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate('/dashManager');
            } else {
                isLoading = false;
                setOriginalData(rd2[0]);
            }

        } catch (error) {
            alert("Errore nel caricamento della pagina, riprova più tardi");
            console.log(error);
            navigate('/dashManager');
        }
    };

    const handleAnnulla = () => {
        setPreavviso(originalData.GiorniPreavvisoManutenzione);
        if(toggleRef.current){
            toggleRef.current.setValue(originalData.InvioMailRiepilogo);
        }
        setMailRiepilogo(originalData.GiorniMailRiepilogo);
    };

    const handleConfirm = async () => {

        if (preavviso <= 0 || mailRiepilogo <= 0) {
            alert("Inserire un valore valido");
            return;
        }

        try {
            isLoading = true;
            let toggleStatus = false;
            if(toggleRef.current){
                toggleStatus = toggleRef.current.getValue();
            }
            const response = await fetch("/aggiornaParametriManager", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    PreavvisoManutenzione: preavviso,
                    InvioMailRiepilogo: toggleStatus,
                    GiorniMailRiepilogo: mailRiepilogo,
                }),
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            } else {
                isLoading = false;
                window.location.reload();
            }

        } catch (error) {
            alert("Errore nel salvataggio delle impostazioni, riprova più tardi");
            console.log(error);
            window.location.reload();
        }
    };

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare il dominio?")) { return; }
        try {
            isLoading = true;
            const response = await fetch("/eliminaDominio", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente.CodiceDominio }),
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            } else {
                isLoading = false;
                navigate("/");
            }
        } catch (error) {
            alert("Errore nell'eliminazione del dominio, riprova più tardi");
            console.log(error);
            return;
        }
    };

    const handleLicenza = () => {
        navigate("/dashManager/impostazioni/licenza");
    };

    return (
        <div className='min-h-screen bg-white dark:bg-gray-800'>
            <NavBar page={"IMPOSTAZIONI"} />
            {isLoading && <Loader />}
            <div className="flex justify-center min-h-screen p-4">
                <div className="w-full max-w-lg text-center bg-white dark:bg-gray-800 text-black dark:text-white mt-14">
                    <div className="rounded-lg bg-gray-300 dark:bg-gray-500 border-solid border-2 border-black p-4">
                        <div className=" grid grid-cols-2 items-center py-4">
                            <p className="justify-self-start">Preavviso per manutenzione (gg): </p>
                            <input
                                type="number"
                                placeholder="Preavviso"
                                className="rounded bg-gray-300 dark:bg-gray-500 border-2 border-gray-400 dark:border-gray-600 px-1 text-center justify-self-end w-full"
                                value={preavviso}
                                min={1}
                                max={90}
                                onChange={(e) => setPreavviso(e.target.value)}
                            />
                        </div>
                        <div className="grid grid-cols-2 items-center py-4">
                            <p className="justify-self-start">Invio della mail di riepilogo al manager: </p>
                            <div className='justify-self-center'>
                                <ToggleSwitch ref={toggleRef} />
                            </div>
                        </div>
                        <div className=" grid grid-cols-2 items-center py-4">
                            <p className="justify-self-start">Invio della mail di riepologo (gg): </p>
                            <input
                                type="number"
                                id="mailRiepilogo"
                                placeholder="Tempo"
                                className={`rounded bg-gray-300 dark:bg-gray-500 border-2 border-gray-400 dark:border-gray-600 px-1 text-center w-full ${toggleRef.current ? '' : 'hover:cursor-not-allowed'}`}
                                disabled={!toggleRef.current}
                                min={1}
                                max={90}
                                value={mailRiepilogo}
                                onChange={(e) => setMailRiepilogo(e.target.value)}
                            />
                        </div>
                        <div className='grid grid-cols-2 py-4'>
                            <button
                                onClick={handleAnnulla}
                                className="mr-1 rounded-lg bg-red-500 hover:bg-red-700 text-white font-bold p-2"
                            >
                                Annulla
                            </button>
                            <button
                                onClick={handleConfirm}
                                className="mr-1 rounded-lg bg-green-500 hover:bg-green-700 text-white font-bold p-2"
                            >
                                Salva
                            </button>
                        </div>
                    </div>
                    <div className='grid grid-cols-2 py-4'>
                        <button
                            onClick={handleElimina}
                            className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                        >
                            ELIMINA DOMINIO
                        </button>
                        <button
                            onClick={handleLicenza}
                            className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                        >
                            LICENZA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImpostazioniManager;